import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsBannerComponent } from '@spartacus/core';

const prebook_Confirmed = 'prebook_confirmed_';

@Component({
  selector: 'app-prebook-userform',
  standalone: false,
  templateUrl: './prebook-userform.component.html',
  styleUrls: ['./prebook-userform.component.scss']
})
export class PrebookUserformComponent implements OnInit, OnDestroy {
  customerForm!: FormGroup;
  orderId!: string;
  userdata: any;
  seqiruscontact: any;
  invoiceaddress: any;
  deliveryaddress: any;
  salescontact: any;
  deliverycontact: any;
  isSubmitted = false;
  deliverySlotArray: any;
  licensename: any;
  reviewData: any;
  maxDeliverySlots: number = 4;
  errormessage = false;
  licenseNumbers: any;
  products: any[] = [];
  data: Observable<any> = this.component.data$;
  constructor(private fb: FormBuilder, private userinfoservice: UserInfoService, private route: ActivatedRoute, public component: CmsComponentData<CmsBannerComponent>, private cd: ChangeDetectorRef, private router: Router) {
    this.customerForm = this.fb.group({
      name: ['', Validators.required],
      position: ['', [Validators.required]]
    });
  }
  ngOnInit() {
    const fullUrl = this.route.snapshot.url;
    this.orderId = fullUrl[fullUrl.length - 1]?.path;
    this.getPrebookForm();
    window.addEventListener('storage', this.handleStorageEvent);
  }
  ngOnDestroy() {
    window.removeEventListener('storage', this.handleStorageEvent);
  }
  private handleStorageEvent = (event: StorageEvent) => {
    //in this fuction iam checking the conditions that is the order id matching and is order confirmed and checks if order is  not submitted from this tab so that if could show already confimed screen directly and doesnt show thankyou screen
    if (event.key === `${prebook_Confirmed}${this.orderId}` && event.newValue && !this.isSubmitted) {
      //if the condition pases then for this user iam setting confirmedOrder to true
      this.userdata = { ...(this.userdata || {}), confirmedOrder: true };
      this.cd.detectChanges();
    }
  };
  getPrebookForm(): void {
    this.userinfoservice.getpreebookform(this.orderId).subscribe({
      next: (res) => {
        // this.userdata = res;
        // this.seqiruscontact = res?.seqirusContactDetails;
        // this.invoiceaddress = this?.reviewData.invoiceAddress;
        // this.deliveryaddress = this?.reviewData.deliveryAddress;
        // this.salescontact = this?.reviewData.salesContact;
        // this.reviewData = res?.reviewData;
        // this.products = this.reviewData?.cartEntries?.[0]?.products || [];
        // this.deliverycontact = this.reviewData?.cartEntries?.map((e: any) => e.deliveryContact) || [];       
        // this.licenseNumbers =
        //   this.reviewData?.cartEntries?.map(
        //     (entry: any) => entry.licenseInfo?.number
        //   ) || [];
        this.userdata = res;

        this.seqiruscontact = res?.seqirusContactDetails;

        this.reviewData = res?.reviewData;

        this.invoiceaddress = this.reviewData?.invoiceAddress;
        this.deliveryaddress = this.reviewData?.deliveryAddress;
        this.salescontact = this.reviewData?.salesContact;

        this.products = this.reviewData?.cartEntries?.[0]?.products || [];

        this.deliverycontact =
          this.reviewData?.cartEntries?.map((e: any) => e.deliveryContact) || [];

        this.licenseNumbers =
          this.reviewData?.cartEntries?.map(
            (entry: any) => entry.licenseInfo?.number
          ) || [];

        this.licensename = this.reviewData?.cartEntries?.map(
          (entry: any) => entry.licenseInfo?.name
        ) || [];

        this.deliverySlotArray = res?.reviewData?.cartEntries?.[0]?.products?.[0]?.deliverySlots
          ? res?.reviewData?.cartEntries?.[0]?.products?.[0]?.deliverySlots
          : res?.reviewData?.cartEntries?.[0]?.products?.[1]?.deliverySlots;
        const constraints = JSON.parse(res?.constraintList || '{}');
        this.maxDeliverySlots = constraints?.maxDeliverySlots - 1;
        this.cd.detectChanges();
      },
      error: (err) => {
        this.errormessage = true;
        this.scrollToTop();
        this.cd.detectChanges();
      }
    });
  }
  onSubmit() {
    if (this.customerForm.invalid) {
      return;
    }
    const payload = {
      orderID: this.orderId,
      approverName: this.customerForm.value.name,
      approverPosition: this.customerForm.value.position,
      orderType: 'confirmOrder', // constant
      orderStatus: this.userdata?.orderStatus, // constant
    };
    this.userinfoservice.postprebookform(payload).subscribe({
      next: (res) => {
        console.log('Success:', res);
        if (res == "SUCCESS" || res == "Success") {
          this.isSubmitted = true;
          try {
            //here iam setting timestamp instead of true because if we are doing the same order id mulyiple time then it was not working
            localStorage.setItem(`${prebook_Confirmed}${this.orderId}`, Date.now().toString());
          } catch (e) {
            console.warn('Unable to broadcast prebook confirmation across tabs', e);
          }
          this.scrollToTop();
        }
        else {
          this.errormessage = true;
          this.scrollToTop();
        }
        this.cd.detectChanges();
      },
      error: (err) => {
        this.errormessage = true;
        this.cd.detectChanges();
      }
    });
  }
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
